import Proptypes from 'prop-types'
import { isPartVisible } from 'utils/displayByDateAndTime'
import Audio from 'components/Audio'
import SoundCloud from 'components/SoundCloud'

export const PartAudio = ({ part, partIndex }) => {

  if (!isPartVisible(part)) return null
  if (!part || !part.url || part.url.length <= 0) return null

  switch (part.type) {
    case 'Audio':
      return <Audio part={part} partIndex={partIndex} />
    case 'SoundCloud':
      return <SoundCloud part={part} />
    default:
      return null
  }
}

PartAudio.propTypes = {
  part: Proptypes.object,
  partIndex: Proptypes.number,
}

export default PartAudio
